// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canRemoveSpaceMembership } from "./check";

export function useCanRemoveSpaceMembership(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canRemoveSpaceMembership(withinScope);
  return canDoAction;
}
